import type {
  IOvieHealthCategoryCount,
  IOvieHealthIntentCount,
  IOvieHealthOutcomeCount,
} from './analytics-common';

export enum OvieHealthAppointmentOutcomeKey {
  AppointmentBooked = 'appointment_booked',
  EnquiryResolved = 'enquiry_resolved',
  Transferred = 'transferred',
  Abandoned = 'abandoned',
  EmergencyHandled = 'emergency_handled',
  AppointmentRescheduled = 'appointment_rescheduled',
}

export type IOvieHealthAppointmentOutcomes = Record<
  OvieHealthAppointmentOutcomeKey,
  number
>;

export interface IOvieHealthAfterHoursAppointments {
  total: number;
  booked: number;
  intents: IOvieHealthIntentCount[];
  outcomes: IOvieHealthOutcomeCount[];
}

export interface IOvieHealthAppointmentAnalytics {
  appointmentsBooked: number;
  appointmentsRescheduled: number;
  totalBookingsManaged: number;
  newPatients: number;
  treatmentBreakdown: IOvieHealthCategoryCount[];
  outcomes: IOvieHealthAppointmentOutcomes;
  afterHours: IOvieHealthAfterHoursAppointments;
}
